/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-12-06
 * @brief EHP Intro 컴포넌트
 *
 ********************************************************************/
import React from "react";
// recoli & state
import { useRecoilValue } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
// UTILS
import * as CONST from "../../../utils/Const";
import * as utils from "./SiteUtils";
/**
 * @brief EHP Intro 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
//
function SiteIntro(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("main", { className: "container", style: { "cursor": "default" } },
            React.createElement("section", { className: "content" },
                React.createElement("article", null,
                    React.createElement("div", { className: "content__title" },
                        React.createElement("div", { className: "title-wrap" },
                            React.createElement("h1", null,
                                React.createElement("img", { src: `${require("/static/img/intro_logo.png")}`, alt: "LS ELECTRIC", className: "mr-15" }),
                                "\uC804\uB825\uC124\uBE44 \uC9C4\uB2E8\uC810\uAC80 \uC11C\uBE44\uC2A4"),
                            React.createElement("h2", null,
                                React.createElement("img", { src: `${require("/static/img/logo_title_color_opacity.png")}`, alt: "e-Health Portal" }),
                                "\uC11C\uBE44\uC2A4 \uC18C\uAC1C"),
                            React.createElement("p", null, "e-Health Portal\uC740 LS ELECTRIC\uC758 \uC804\uB825\uC124\uBE44 \uC9C4\uB2E8\uC810\uAC80 \uC11C\uBE44\uC2A4\uB97C \uC885\uD569\uC801\uC73C\uB85C \uC81C\uACF5\uD558\uB294 Web Portal\uC785\uB2C8\uB2E4."),
                            React.createElement("p", null, "Cloud \uAE30\uBC18\uC73C\uB85C PC \uBC0F Mobile \uB3D9\uC2DC \uC9C0\uC6D0\uD558\uC5EC \uC5B8\uC81C \uC5B4\uB514\uC11C\uB098 \uC804\uB825\uC124\uBE44 \uC9C4\uB2E8\uC810\uAC80 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."))),
                    React.createElement(Main, null))))));
}
export default SiteIntro;
function Main() {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    let main = utils.main;
    let sub = utils.sub;
    let imgs = utils.imgs;
    return (React.createElement(React.Fragment, null, main.map((menu, idx) => (React.createElement("section", { key: "intro_" + idx.toString() },
        React.createElement("h3", null, menu.title),
        React.createElement("p", { className: "addmean" }, menu.text),
        (userInfo.loginInfo.role == CONST.USERROLE_ADMIN) ?
            React.createElement("div", { className: "cont" },
                sub.filter((fd) => (fd.code.toString() == menu.code)).map((smenu, idx) => (React.createElement("dl", { key: "intro_" + idx.toString() },
                    React.createElement("dt", null, smenu.subTitle),
                    React.createElement("dd", null, smenu.subText)))),
                imgs.filter((fd) => (fd.code.toString() == menu.code)).map((img, idx) => (React.createElement("div", { className: "img-wrap", key: "intro__" + idx.toString() },
                    React.createElement("img", { src: img.item, alt: "" })))))
            :
                React.createElement("div", { className: "cont" },
                    sub.filter((fd) => (fd.code.toString() == menu.code) && (fd.code.toString() != "management")).map((smenu, idx) => (React.createElement("dl", { key: "intro_" + idx.toString() },
                        React.createElement("dt", null, smenu.subTitle),
                        React.createElement("dd", null, smenu.subText)))),
                    imgs.filter((fd) => (fd.code.toString() == menu.code) && (fd.code.toString() != "management")).map((img, idx) => (React.createElement("div", { className: "img-wrap", key: "intro__" + idx.toString() },
                        React.createElement("img", { src: img.item, alt: "" }))))))))));
}
